import React, { useRef } from "react";
import * as Preloader from "../../../../../../../common-deprecated/styles/v2/toyota/custom/Preloader";
import * as Styles from "./styles/ExteriorSpinStyle";
import IconReset from "../../../../../../../common-deprecated/svg/v2/toyota/refresh.svg";
import useExteriorSpin3D from "../../../../hooks/customize/useExteriorSpin3D";
import { BnbLabel } from "../../../../utils/labels";

// TODO: If `IconReset` is available in the IconFont, change this to the icon-font icon

const ExteriorSpin3D = (): JSX.Element => {
    const canvasRef = useRef<HTMLCanvasElement>(null);
    const { loading, loadingPercentage, showReset, resetCar } = useExteriorSpin3D(canvasRef);

    return (
        <Styles.Wrapper3dSpin>
            {loading && (
                <Preloader.Wrapper isBoxed>
                    <Preloader.default hasLabel />
                    <Preloader.Percentage hasLabel>{loadingPercentage}%</Preloader.Percentage>
                    <Preloader.Label>
                        <BnbLabel label="spin3DLoading" />
                    </Preloader.Label>
                </Preloader.Wrapper>
            )}
            {showReset && (
                <Styles.ResetButton onClick={resetCar}>
                    <BnbLabel label="spin3DReset" />
                    <IconReset />
                </Styles.ResetButton>
            )}
            <Styles.Spin3dCanvas ref={canvasRef} hidden={loading} />
        </Styles.Wrapper3dSpin>
    );
};

export default ExteriorSpin3D;
